import { render, staticRenderFns } from "./customCmp.vue?vue&type=template&id=14bd94e2&"
import script from "./customCmp.vue?vue&type=script&lang=ts&"
export * from "./customCmp.vue?vue&type=script&lang=ts&"
import style0 from "./customCmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports